import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setDataProcessingGroupByProgressData } = slice.actions;

const getDataProcessingGroupByProgress = (url: any) => async () => {
  try {
    const response = await API.dataProcessingGroupByProgress.dataProcessingGroupByProgress(url);
    dispatch(setDataProcessingGroupByProgressData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error) {}
};

export default {
  getDataProcessingGroupByProgress
};
